export default [
    {
        path: process.env.IS_LOCAL === 'true' ? '' : '' + '/admin',
        name: 'admin',
        component: () => import('@/pages/Admin/Main'),
    },
    {
        path: process.env.IS_LOCAL === 'true' ? '' : '' + '/regions',
        name: 'regions',
        component: () => import('@/pages/Admin/Regions'),
    },
    {
        path: process.env.IS_LOCAL === 'true' ? '' : '' + '/co',
        name: 'co',
        component: () => import('@/pages/Admin/Co'),
    },
    {
        path: process.env.IS_LOCAL === 'true' ? '' : '' + '/organizations',
        name: 'organizations',
        component: () => import('@/pages/Admin/Organizations'),
    },
    {
        path: process.env.IS_LOCAL === 'true' ? '' : '' + '/appeals-org',
        name: 'appeals-org',
        component: () => import('@/pages/Admin/OrgAppeals'),
    },
    {
        path: process.env.IS_LOCAL === 'true' ? '' : '' + '/appeals-fives',
        name: 'appeals-fives',
        component: () => import('@/pages/Admin/FormsFiveAppeals'),
    },
    {
        path: process.env.IS_LOCAL === 'true' ? '' : '' + '/appeals-indicators',
        name: 'appeals-indicators',
        component: () => import('@/pages/Admin/ViewIndicatorsAppeals'),
    },
    {
        path: process.env.IS_LOCAL === 'true' ? '' : '' + '/founders',
        name: 'founders',
        component: () => import('@/pages/Admin/Founders'),
    },
    {
        path: process.env.IS_LOCAL === 'true' ? '' : '' + '/envelopes',
        name: 'envelopes',
        component: () => import('@/pages/Admin/Envelopes'),
    }
].map(el => ({...el,
    meta: {
        needContact: false,
        isAdmin: true
    }
}))